export default __webpack_public_path__ + "static/media/ned.aa609d26.svg";